import React, { useState, useContext, useEffect, useRef } from "react";

import { useScreenTransition } from "../../Hooks/useScreenTransition";

import { AuthContext } from "../../Context/AuthContext";
import { TransitionContext } from "../../Context/TransitionContext";

import { languages } from "../../Data/languages";
import { ReactComponent as SEARCHICON } from "../../assets/icons/search.svg";
import { ReactComponent as DOWN } from "../../assets/icons/filter-down.svg";
import { ReactComponent as UP } from "../../assets/icons/filter-up.svg";
import { ReactComponent as SORTBLACK } from "../../assets/icons/sort-black.svg";
import { ReactComponent as MORE } from "../../assets/icons/More.svg";
import { ReactComponent as MORESELECTED } from "../../assets/icons/More-selected.svg";
import { ReactComponent as MESSAGE } from "../../assets/icons/Message-icons.svg";
import { ReactComponent as STATUS } from "../../assets/icons/Status.svg";
import { ReactComponent as DATE } from "../../assets/icons/Date.svg";
import { ReactComponent as LANGUAGES } from "../../assets/icons/Languages.svg";
import { ReactComponent as SERVICES } from "../../assets/icons/Services.svg";
import { ReactComponent as EXPEDITED } from "../../assets/icons/order-expedited.svg";
import { ReactComponent as EXPEDITEDPLUS } from "../../assets/icons/expedited-plus.svg";
import { ReactComponent as HARDCOPY } from "../../assets/icons/order-hard-copy.svg";
import { ReactComponent as NOTRY } from "../../assets/icons/order-notry.svg";
import { ReactComponent as PLACEDBY } from "../../assets/icons/placed-by.svg";
import { ReactComponent as CANCELORDER } from "../../assets/icons/cancel-order.svg";
import { ReactComponent as SORT_ASC } from "../../assets/icons/sort-asc.svg";
import { ReactComponent as SORT_DSC } from "../../assets/icons/sort-dsc.svg";
import { ReactComponent as INFO } from "../../assets/icons/Info.svg";
import { ReactComponent as CLIENT } from "../../assets/icons/Client.svg";
import { ReactComponent as Trash } from "../../assets/icons/Trash.svg";

import AccountNavBar from "../../NewComponents/AccountNavBar";
import NoData from "../../NewComponents/NoData";
import { DataContext } from "../../Context/DataContext";
import SearchFilter from "./OrdersComponents/SearchFilter";
import DateFilter from "./OrdersComponents/DateFilter";
import LanguageFilter from "./OrdersComponents/LanguageFilter";
import PopUpModal from "../../NewComponents/PopUpModal";

import JSZip from "jszip";
import { saveAs } from "file-saver";
import Docxtemplater from "docxtemplater";
import PizZip from "pizzip";
import PizZipUtils from "pizzip/utils/index.js";
import SendPaymentLinkPopUp from "../../NewComponents/SendPaymentLinkPopUp";
import Clientsfilter from "./OrdersComponents/Clientsfilter.js";
import { ORDERSTATUS } from "../../Data/statuses";
import {
  checkAutoBilling,
  decrTeamFreeExpedOrder,
  formatTotal,
  getClients,
  getDiscount,
  getExpedited,
  getHardCopyPrice,
  getOrderPageCountTotal,
  getShortOrderNo,
  getTotal,
  signaturePrice,
} from "../../Data/Functions/index.js";
import "./Orders.css";
import { checkFetchAlgoliaData, firestore, getFullHttpUrl } from "../../firebase.config.js";
import MessageDot from "../../NewComponents/MessageDot.js";
import { Configure, Pagination, SearchBox, useHits, useInstantSearch, useSearchBox, useSortBy } from "react-instantsearch-hooks-web";
import OpenInvoiceModal from "../../NewComponents/OpenInvoiceModal.js";
import axios from "axios";
import { NotificationContext } from "../../Context/NotificationContext.js";
import { Link, useLocation, useParams } from "react-router-dom";
import QueryFilters from "./OrdersComponents/QueryFilters.js";

 export const sampleOrdersData = [
    {
    objectID: "1234567890",
    id: "1234567890",
    sample: true,
    certified: true,
    discount: 0,
    discountApplied: false,
    expedited: true,
    files: [{format: "application/pdf", name: "sample_file.pdf", ref: "SampleOrder/sample_file.pdf", size: 4911, timestamp: 1755902180834, type: "source", url: "https://firebasestorage.googleapis.com/v0/b/project-everbary.appspot.com/o/SampleOrder%2Fsample_file.pdf?alt=media&token=45353bbb-b20c-426c-9fcb-1ccd0260ddfc"}],
    generalNotes: "",
    hardCopy: false,
    hardCopyExtra: null,
    hardCopyStatus: null,
    languageFrom: "spanish",
    languageTo: "english",
    email: "kathryn@murphy .com",
    clientFirstName: "Juan",
    clientLastName: "Alvarado",
    firstName: "Kathryn",
    lastName: "Murphy ",
    name: "Kathryn Murphy ",
    notarization: false,
    notarizationStatus: null,
    notes: "",
    notified: false,  
    orderNumber: 95095,
    pagesCount: "1",
    paypalOrderID: "paid",
    status: "new",
    teamId: "1234567890",
    timestamp: 1755902188277,
    type: "business",
    userID: "1234567890",
    userNotes: "",
    wordCount: 0,
  },
  {
    objectID: "1234567891",
    id: "1234567891",
    sample: true,
    certified: true,
    discount: 0,
    discountApplied: false,
    expedited: true,
    files: [{format: "application/pdf", name: "sample_file.pdf", ref: "SampleOrder/sample_file.pdf", size: 4911, timestamp: 1755902180834, type: "source", url: "https://firebasestorage.googleapis.com/v0/b/project-everbary.appspot.com/o/SampleOrder%2Fsample_file.pdf?alt=media&token=45353bbb-b20c-426c-9fcb-1ccd0260ddfc"}],
    generalNotes: "",
    hardCopy: false,
    notarization: true,
    hardCopyExtra: null,
    hardCopyStatus: null,
    languageFrom: "portugueseBrazil",
    languageTo: "english",
    email: "darlene@robertson.com",
    clientFirstName: "Felix",
    clientLastName: "Goncalves",
    firstName: "Darlene",
    lastName: "Robertson",
    name: "Darlene Robertson",
    notarizationStatus: null,
    notes: "",
    notified: false,  
    orderNumber: 95096,
    pagesCount: "1",
    paypalOrderID: "paid",
    status: "in-progress",
    teamId: "1234567890",
    timestamp: 1755902188277,
    type: "business",
    userID: "1234567890",
    userNotes: "",
    wordCount: 0,
  },
  {
    objectID: "1234567892",
    id: "1234567892",
    sample: true,
    certified: true,
    discount: 0,
    discountApplied: false,
    expedited: false,
    expeditedPlus: true,
    files: [{format: "application/pdf", name: "sample_file.pdf", ref: "SampleOrder/sample_file.pdf", size: 4911, timestamp: 1755902180834, type: "source", url: "https://firebasestorage.googleapis.com/v0/b/project-everbary.appspot.com/o/SampleOrder%2Fsample_file.pdf?alt=media&token=45353bbb-b20c-426c-9fcb-1ccd0260ddfc"}],
    generalNotes: "",
    hardCopy: true,
    hardCopyExtra: {
      method: "priority",
      country: "United States",
      signature: true,
    },
    hardCopyStatus: "pending",
    languageFrom: "albanian",
    languageTo: "english",
    email: "cameronus@williamson.com",
    clientFirstName: "Amelia",
    clientLastName: "Hoxha",
    firstName: "Cameronus",
    lastName: "Williamson",
    name: "Cameronus Williamson",
    notarization: true,
    notarizationStatus: null,
    notes: "",
    notified: false,  
    orderNumber: 95097,
    pagesCount: "1",
    paypalOrderID: "paid",
    status: "completed",
    teamId: "1234567890",
    timestamp: 1755902188277,
    type: "business",
    userID: "1234567890",
    userNotes: "",
    wordCount: 0,
  },
]

const AccountOrdersComponent = ({ windowSize }) => {
  const { transitionTo } = useScreenTransition();

  const { setColor } = useContext(TransitionContext);
  const { userData, teamData, order : localOrder, setOrder } = useContext(DataContext);
  const { signedIn } = useContext(AuthContext);

  const [moreOptions, setMoreOptions] = useState("");
  const [showDetailModal, setShowDetailModal] = useState("");

  const [statusFilter, setStatusFilter] = useState("");
  const [servicesFilter, setServicesFilter] = useState([]);

  const [showFilter, setShowFilter] = useState("");

  const [filterStartTimestamp, setFilterStartTimestamp] = useState(null);
  const [filterEndTimestamp, setFilterEndTimestamp] = useState(null);
  const [selectedLanguageFilter, setSelectedLanguageFilter] = useState({
    languageFrom: "",
    languageTo: "",
  });
  const [datePeriod, setDatePeriod] = useState("custom");

  const [clients, setClients] = useState([]);
  const [teamMembers, setTeamMembers] = useState([]);

  const [selectedClients, setSelectedClients] = useState([]);
  const [selectedMembers, setSelectedMembers] = useState([]);

  const [selectedCancelModal, setSelectedCancelModal] = useState("");
  const [cancelBtnText, setCancelBtnText] = useState("Cancel Order");
  const [selectedSendPayment, setSelectedSendPayment] = useState("");
  const [orderUpdated, setOrderUpdated] = useState(false);
  const [openInvoiceModal, setOpenInvoiceModal] = useState();
  const [selectedPayment, setSelectedPayment] = useState();
  const [paylaterBtn, setPaylaterBtn] = useState("Pay Later");

  const { showNotification } = useContext(NotificationContext);

  const moreOptionsRef = useRef(null);

  
  
  useEffect(() => {
    setColor(true);
  }, [setColor]);
  
  const [localOrders, setLocalOrders] = useState([]);

  useEffect(()=> {
    if(!checkFetchAlgoliaData()){
      if(signedIn && userData.id){
        firestore.collection("orders").where(userData.teamId ? "teamId" : "userID", "==", userData.teamId ?? userData.id).orderBy("timestamp", "desc").get()
        .then(qSnap => {
          if(qSnap.empty){
            return;
          }

          setLocalOrders(qSnap.docs.map(doc => ({...doc.data(), objectID: doc.id})));
        })
      }
    }

  }, 
  [userData,teamData])

  useEffect(() => {
    if (signedIn && userData && userData.teamId) {

      getClients(userData, setClients, "order");

      firestore
        .collection("users")
        .where("teamId", "==", userData.teamId).orderBy("name", "asc")
        .get()
        .then((qSnap) => {
          if (!qSnap.empty) {
            setTeamMembers(
              qSnap.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
            );
          }
        });
    }
  }, [signedIn, userData]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.hardCopyAddressIconWrap')) {
        setMoreOptions("");
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const formatDate = (timestamp, showTime = false) => {
    const date = new Date(timestamp);

    const splitted = date.toDateString().split(" ");

    const time = showTime ? " @ " + date.toTimeString().substr(0, 5) : "";

    return splitted[1] + " " + splitted[2] + ", " + splitted[3] + time;
  };

  const getLanguage = (language) => {
    if (languages.find((lang) => lang.value === language)) {
      return languages.find((lang) => lang.value === language).label;
    } else {
      return "";
    }
  };


  const formatDiscount = (value) => {
    return "-$" + value.toFixed(2);
  };

  const formatFilterDate = (date) => {
    return (
      date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear()
    );
  };

  const getSelectedDateText = () => {
    if (filterStartTimestamp) {
      if (filterEndTimestamp) {
        return (
          formatFilterDate(new Date(filterStartTimestamp)) +
          " - " +
          formatFilterDate(new Date(filterEndTimestamp))
        );
      } else {
        return (
          formatFilterDate(new Date(filterStartTimestamp)) +
          " - " +
          formatFilterDate(new Date())
        );
      }
    } else {
      return "Date";
    }
  };

  const getLanguageLabel = (value) => {
    const language = languages.find((l) => l.value === value);

    if (language) {
      return language.label;
    } else {
      return "";
    }
  };

  const getSelectedLanguage = () => {
    if (
      selectedLanguageFilter.languageFrom !== "" &&
      selectedLanguageFilter.languageTo !== ""
    ) {
      return (
        getLanguageLabel(selectedLanguageFilter.languageFrom) +
        " to " +
        getLanguageLabel(selectedLanguageFilter.languageTo)
      );
    } else {
      return "Languages";
    }
  };

  const checkAnyFilterSelected = () => {
    if (filterStartTimestamp) {
      return true;
    }
    if (filterEndTimestamp) {
      return true;
    }
    if (
      selectedLanguageFilter.languageFrom &&
      selectedLanguageFilter.languageTo
    ) {
      return true;
    }
    if (selectedMembers.length > 0) {
      return true;
    }
    if (selectedClients.length > 0) {
      return true;
    }
    if (servicesFilter.length > 0) {
      return true;
    }
    if (statusFilter !== "") {
      return true;
    }
    return false;
  };

  const handleCancelOrder = (isPaid) => {
    setCancelBtnText("Cancelling...");

    firestore
      .collection("orders")
      .doc(selectedCancelModal.id)
      .update({
         status: isPaid ? "on-hold" :
          selectedCancelModal.status === "new" || selectedCancelModal.status === "draft"
            ? "cancelled"
            :  "on-hold",
          cancellationHold: isPaid ? true:
          selectedCancelModal.status === "new" || selectedCancelModal.status === "draft"
            ? false
            :  true
      })
      .then(() => {
        setTimeout(() => {
          setOrderUpdated((o) => !o);
          setCancelBtnText("Cancel Order");
          setSelectedCancelModal("");
          refresh();
        }, 3000);
      });
  };
  const handleDownloadOrder = (order) => {
    setMoreOptions("");
    setOpenInvoiceModal(order);
  };

  const downloadPackage = (order) => {
    setMoreOptions("");
    generateDocument(order);
  };

  const downloadFolderAsZip = async (order, invoiceFile) => {
    const jszip = new JSZip();
    const sourceFiles = order.files.filter(
      (f) =>
        f.type === "source" || f.type === "reference" || f.type === "client"
    );
    const translatedFiles = order.files.filter(
      (f) =>
        (f.type === "translation" ||
          (f.type === "revision" &&
            (order.status === "user-review" ||
              order.status === "completed"))) &&
        (!order.certified || f.format === "application/pdf")
    );
    const downloadedFiles = await Promise.all(
      sourceFiles
        .concat(translatedFiles)
        .map((file) => fetch(file.url).then((res) => res.blob()))
    );
    downloadedFiles.forEach((file, i) => jszip.file(order.files[i].name, file));
    jszip.file(`invoice_${order.orderNumber}.docx`, invoiceFile);
    const content = await jszip.generateAsync({ type: "blob" });
    saveAs(content, `${order.orderNumber}`);
  };

  function loadFile(url, callback) {
    PizZipUtils.getBinaryContent(url, callback);
  }

  const generateDocument = (orderInfo) => {
    loadFile(
      "https://firebasestorage.googleapis.com/v0/b/project-everbary.appspot.com/o/invoiceTemplate.docx?alt=media&token=5b304c5f-5863-4e89-ac4c-3da7464e343e",
      function (error, content) {
        if (error) {
          throw error;
        }
        const zip = new PizZip(content);
        const doc = new Docxtemplater(zip);
        doc.render({
          orderNumber: orderInfo.orderNumber,
          orderDate: formatDate(orderInfo.timestamp, true),
          orderReference: orderInfo.reference || "",
          name: teamData ? teamData.name : orderInfo.name,
          email: orderInfo.email,
          translationType: orderInfo.certified
            ? "Certified Translation"
            : "Standard Translation",
          pages: orderInfo.certified
            ? orderInfo.pagesCount !== ""
              ? orderInfo.pagesCount +
              " pages (" +
              parseInt(orderInfo.pagesCount, 10) * 250 +
              " words max)"
              : "0 pages (0 words max)"
            : orderInfo.wordCount !== ""
              ? orderInfo.wordCount + " words"
              : "0 words",
          unitPrice: "24.95",
          pageTotal:
            orderInfo.pagesCount !== ""
              ? "$" + getOrderPageCountTotal(orderInfo).toFixed(2)
              : "$0.00",
          notaryCount: orderInfo.notarization ? "1" : "",
          notaryUnit: orderInfo.notarization ? "$34.90" : "",
          notaryPrice: orderInfo.notarization ? "$34.90" : 0,
          expedited: orderInfo.expeditedPlus
            ? "Expedited Plus Turnaround"
            : "Expedited Turnaround",
          expeditedPrice:
            orderInfo && orderInfo.expedited
              ? formatTotal(getExpedited(orderInfo))
              : "",
          hardCopy:
            orderInfo.hardCopy &&
              orderInfo.hardCopyExtra.country !== "" &&
              orderInfo.hardCopyExtra.method !== ""
              ? `USPS ${orderInfo.hardCopyExtra.method.charAt(0).toUpperCase() +
              orderInfo.hardCopyExtra.method.slice(1)
              } Mail ${![
                "United States",
                "Puerto Rico",
                "U.S. Virgin Islands",
              ].includes(orderInfo.hardCopyExtra.country)
                ? "International"
                : "Hard Copy"
              }`
              : "Hard Copy",
          hardCopyPrice: getHardCopyPrice(
            orderInfo.hardCopy && orderInfo.hardCopyExtra.country,
            orderInfo.hardCopy && orderInfo.hardCopyExtra.method,
            false,
            orderInfo
          ),
          signature: signaturePrice(
            orderInfo.hardCopy && orderInfo.hardCopyExtra.requireSignature,
            orderInfo
          ),
          signaturePrice: signaturePrice(
            orderInfo.hardCopy && orderInfo.hardCopyExtra.requireSignature,
            orderInfo
          ),
          subTotal: orderInfo ? formatTotal(getTotal(orderInfo)) : 0,
          discountPercent:
            orderInfo.discount && orderInfo.discount > 0
              ? `(${orderInfo.discount}%)`
              : "",
          discount:
            orderInfo && orderInfo.discount && orderInfo.discount > 0
              ? formatDiscount(getDiscount(orderInfo))
              : 0,
          total: orderInfo
            ? formatTotal(getTotal(orderInfo) - getDiscount(orderInfo))
            : 0,
        });

        const out = doc.getZip().generate({
          type: "blob",
          mimeType:
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        });

        downloadFolderAsZip(orderInfo, out);
      }
    );
  };

  const {hits} = useHits();
  const {status, refresh} = useInstantSearch();
  const {query} = useSearchBox();
  const [loading, setLoading] = useState(true);
  
  
  const items = [
      {
      Label: "Default",
      value: "orders"
      },
      {
      Label: "Date asc",
      value: "order_time_asc"
      },
      {
      Label: "Date dsc",
      value: "order_time_dsc"
      },
      {
      Label: "Name asc",
      value: "order_requestBy_asc"
      },
      {
      Label: "Name dsc",
      value: "order_requestBy_dsc"
      },
      {
      Label: "Client asc",
      value: "order_client_asc"
      },
      {
      Label: "Client dsc",
      value: "order_client_dsc"
      },
      {
      Label: "Status asc",
      value: "order_status_asc"
      },
      {
      Label: "Status dsc",
      value: "order_status_dsc"
      },
  ]
  const { currentRefinement, refine } = useSortBy({items: items, defaultRefinement: "order_time_dsc"});
  
  useEffect(() => {
      if(status === "loading" || status === "stalled"){
      setLoading(true);
      }else{
      setLoading(false);
      }
  }, [status])
  
  useEffect(() => {
      if(currentRefinement === "orders"){
      refine("order_time_dsc");
      }
  }, [currentRefinement])
  
  
    const [filters, setFilters] = useState(`userID: ${userData ? userData.id : "no-user"}`);

    useEffect(() => {
        const defalutFilters = userData && userData.teamId ? `teamId: ${userData.teamId}`: `userID: ${userData ? userData.id : "no-user"}`;
        let tempFilters = defalutFilters;
        
        if(filterStartTimestamp && filterEndTimestamp){
            tempFilters += ` AND timestamp >= ${filterStartTimestamp} AND timestamp <= ${filterEndTimestamp}`
        }
        if(selectedLanguageFilter && selectedLanguageFilter.languageFrom && selectedLanguageFilter.languageTo){
            tempFilters += ` AND languageFrom:${selectedLanguageFilter.languageFrom} AND languageTo:${selectedLanguageFilter.languageTo}`;
        }
        if(selectedMembers.length > 0){
            selectedMembers.forEach((email, i) => {tempFilters +=` ${i === 0 ? "AND" : "OR"} email:${email}`});
        }
        if(selectedClients){
            selectedClients.forEach((client, i) => {
                const clientNames = client.split(" ");
                const first = clientNames[0];
                const last = clientNames.length > 1 ? clientNames[1] : "";
                tempFilters +=` ${i === 0 ? "AND" : "OR"} clientFirstName:${first}`
            });
        }
        if (servicesFilter.includes("notry")){
            tempFilters+= ` AND notarization:true`;
        }
        if (servicesFilter.includes("expedited")){
            tempFilters += ` AND expedited:true`;
        }
        if (servicesFilter.includes("expedited+")){
            tempFilters += ` AND expeditedPlus:true`;
        }
        if (servicesFilter.includes("hardCopy")){
            tempFilters+= ` AND hardCopy:true`;
        }
        if(statusFilter){
            tempFilters+= ` AND status:${statusFilter}`;
        }

        if((tempFilters === `teamId: ${userData.teamId}` || tempFilters === `userID: ${userData ? userData.id : "no-user"}`) && query === ""){
          if(!checkFetchAlgoliaData() ? localOrders.length === 0 : hits.length === 0){
            setShowSampleOrders(true);
          }else{
            setShowSampleOrders(false);
          }
        }else{
          setShowSampleOrders(false);
        }

        setFilters(tempFilters);
    }
    , [filterStartTimestamp, filterEndTimestamp, userData, selectedMembers, selectedLanguageFilter, servicesFilter, statusFilter, selectedClients])

    const handleShowMore = (value) => {
        setShowFilter("");
        setMoreOptions(value);
    }

    const [showSampleOrders, setShowSampleOrders] = useState(true);
    
    
    const [sampleOrders, setSampleOrders] = useState(null);
    useEffect(() => {
      if(hits.length === 0){
        const sampleOrders = JSON.parse(localStorage.getItem("sampleOrders"));
        if(!sampleOrders){
          localStorage.setItem("sampleOrders", JSON.stringify(sampleOrdersData));
        }
        setSampleOrders(sampleOrders);
      }
    }, [hits]);

    const onClickSampleDelete = (order)=> {
      const o = sampleOrders.filter(o => o.objectID !== order.objectID);
      localStorage.setItem("sampleOrders", JSON.stringify(o));
      setSampleOrders(o);
    }

    const TableDataComponent = ({hits }) => {

  
      // if(hits.length === 0){
      //   return <tbody></tbody>;
      // }

      const orders = hits.length === 0 && showSampleOrders ? sampleOrders || [] : hits;

      // if((hits.length === 0 || (process.env.REACT_APP_Emulator === "true" && localOrders.length > 0)) ){
      //   return <NoData loadingText={"orders"} loading={false} showBtn={false} type="orders"/>
      // }
  
      return (
        <tbody>
        {orders.map(hit =>
        {
          const order = {...hit, id: hit.objectID}
          return (
             <tr key={order.id} onClick={(e) => transitionTo(`/account/order/${order.id}`, e)}>
              {order.sample ? <td className="quotewidth accountDetailsLink text-[#9A9FA7]">Sample</td> : ""}
                <td onClick={(e) =>
                transitionTo(`/account/order/${order.id}`, e)
                }>
                  <Link to={`/account/order/${order.id}`} onClick={(e) => e.stopPropagation()}>
                    {order.orderNumber && order.orderNumber.toString().length > 12 &&
                        showDetailModal === order.orderNumber && (
                        <div className="accountdetailHoverBox">
                            <p
                            className="quotewidth "
                            >
                            {order.orderNumber}
                            </p>
                        </div>
                        )}
                    <p className="quotewidth accountDetailsLink" 
                        onMouseOver={() =>
                        setShowDetailModal(
                            order.orderNumber
                        )
                        }
                        onMouseLeave={() => setShowDetailModal("")}>
                        {getShortOrderNo(order.orderNumber, "order")}
                    </p>
                  </Link>
                </td>
                <td>
                  <Link to={`/account/order/${order.id}`} onClick={(e) => e.stopPropagation()}>
                    <p className="quotewidth ">
                    {formatDate(order.timestamp)}
                    </p>
                  </Link>
                </td>
                <td>
                  <Link to={`/account/order/${order.id}`} onClick={(e) => e.stopPropagation()}>
                    {showDetailModal ===
                    order.id + order.languageFrom && (
                        <div className="accountdetailHoverBox">
                        <p
                            className="quotewidth captialLetters"
                        >
                            {getLanguage(order.languageFrom) +
                            " / " +
                            getLanguage(order.languageTo)}
                        </p>
                        </div>
                    )}
                    <p
                    className="quotewidth"
                    style={{
                        textTransform: "uppercase",
                        cursor: "pointer",
                    }}
                    onMouseOver={() =>
                        setShowDetailModal(
                        order.id + order.languageFrom
                        )
                    }
                    onMouseLeave={() => setShowDetailModal("")}
                    >
                    {getLanguage(order.languageFrom).substr(0, 2) +
                        "/" +
                        getLanguage(order.languageTo).substr(0, 2)}
                    </p>
                  </Link>
                </td>
                {userData && userData.teamId && (
                  <td>
                    <Link to={`/account/order/${order.id}`} onClick={(e) => e.stopPropagation()}>
                      {order.name.length > 14 &&
                          showDetailModal === order.id + order.name && (
                          <div className="accountdetailHoverBox">
                              <p
                              className="quotewidth captialLetters"
                              >
                              {order.name}
                              </p>
                          </div>  
                          )}
                      <p
                          className="quotewidth  captialLetters overflowText"
                          style={{ cursor: "pointer" }}
                          onMouseOver={() =>
                          setShowDetailModal(order.id + order.name)
                          }
                          onMouseLeave={() => setShowDetailModal("")}
                      >
                          {order.name}
                      </p>
                    </Link>
                    </td>
                )}
                {userData && userData.teamId && (
                    <td>
                    <Link to={`/account/order/${order.id}`} onClick={(e) => e.stopPropagation()}>
                      {order.clientFirstName ? (
                          <>
                          {(order.clientLastName ? order.clientFirstName + " " + order.clientLastName : order.clientFirstName).length > 14 
                          && showDetailModal === order.id + "client" && (
                              <div className="accountdetailHoverBox">
                              <p className="quotewidth captialLetters">
                                  {order.clientFirstName || ""} {order.clientLastName || ""}
                              </p>
                              </div>
                          )}
                          <p
                              className="quotewidth  captialLetters overflowText"
                              style={{ cursor: "pointer" }}
                              onMouseOver={() => setShowDetailModal(order.id + "client")}
                              onMouseLeave={() => setShowDetailModal("")}
                          >
                              {order.clientFirstName || ""} {order.clientLastName || ""}
                          </p>
                          </>
                      ) : (
                          <p className="quotewidth ">-</p>
                      )}
                    </Link>
                    </td>

                )}
                <td>
                  <Link to={`/account/order/${order.id}`} onClick={(e) => e.stopPropagation()}>
                    {showDetailModal === order.id + "N" && (
                    <div className="accountdetailHoverBox">
                        <p
                        className="quotewidth captialLetters"
                        >
                        Notarization
                        </p>
                    </div>
                    )}
                    {showDetailModal === order.id + "E" && (
                    <div className="accountdetailHoverBox">
                        <p
                        className="quotewidth captialLetters"
                        >
                        {order.expeditedPlus
                            ? "Expedited+ Turnaround"
                            : "Expedited Turnaround"}
                        </p>
                    </div>
                    )}
                    {showDetailModal === order.id + "H" && (
                    <div className="accountdetailHoverBox">
                        <p
                        className="quotewidth captialLetters"
                        >
                        Mail Hard Copy
                        </p>
                    </div>
                    )}
                    <p className="quotewidth  captialLetters flex gap-1 ">
                      <p className="opacity-0">.</p>
                    {order.notarization && (
                        <NOTRY
                        style={{ cursor: "pointer" }}
                        onMouseOver={() =>
                            setShowDetailModal(order.id + "N")
                        }
                        onMouseLeave={() => setShowDetailModal("")}
                        />
                    )}
                    {order.expedited && (
                        <EXPEDITED
                        style={{ cursor: "pointer" }}
                        onMouseOver={() =>
                            setShowDetailModal(order.id + "E")
                        }
                        onMouseLeave={() => setShowDetailModal("")}
                        />
                    )}
                    {order.expeditedPlus && (
                        <EXPEDITEDPLUS
                        style={{ cursor: "pointer" }}
                        onMouseOver={() =>
                            setShowDetailModal(order.id + "E")
                        }
                        onMouseLeave={() => setShowDetailModal("")}
                        />
                    )}
                    {order.hardCopy ? (
                        <HARDCOPY
                        style={{ cursor: "pointer" }}
                        onMouseOver={() =>
                            setShowDetailModal(order.id + "H")
                        }
                        onMouseLeave={() => setShowDetailModal("")}
                        />
                    ) : (
                        ""
                    )}
                    </p>
                  </Link>
                </td>
                <td>
                  <Link to={`/account/order/${order.id}`} onClick={(e) => e.stopPropagation()}>
                    {order.sample ? <div className="chatDot" style={{backgroundColor: "#18b7bb"}}></div>
                    : <MessageDot chatId={order.generalChatId}/>}
                    {/* <FileCommentIndicator orderId={order.id} /> */}
                  </Link>
                </td>
                <td>
                  <Link to={`/account/order/${order.id}`} onClick={(e) => e.stopPropagation()}>
                    <p
                    className="quotewidth  accountDetailsStatus"
                    style={{
                        backgroundColor: order.cancellationHold && order.status === "on-hold" ? ORDERSTATUS["cancel-hold"][1] :ORDERSTATUS[order.status]
                        ? ORDERSTATUS[order.status][1]
                        : "",
                    }}
                    >
                    {order.cancellationHold && order.status === "on-hold" ? ORDERSTATUS["cancel-hold"][0] :
                    ORDERSTATUS[order.status]
                        ? ORDERSTATUS[order.status][0]
                        : order.status}
                    </p>
                  </Link>
                </td>
                <td>
                  <Link to={`/account/order/${order.id}`} onClick={(e) => e.stopPropagation()}>
                    <p className="quotewidth">
                    {order.pagesCount === undefined ||
                        order.wordCount === undefined
                        ? ""
                        : formatTotal(
                        getTotal(order) - getDiscount(order)
                        )}
                    </p>
                  </Link>
                </td>
                {checkAutoBilling(teamData) ? (
                    ""
                ) : (
                    <td>
                    {order.status === "cancelled" ? (
                        <p
                        style={{
                            width: "100%",
                            textAlign: "center",
                        }}
                        className="quotewidth "
                        >

                        </p>
                    ) : (
                        <p
                        style={{
                            
                            textAlign: "center",
                        }}
                        className="quotewidth"
                        >
                        {order.status === "created" ? (
                            <button
                            className="accountOrderBtn"
                            onClick={(e) => {
                                setSelectedPayment(order);
                            }}
                            >
                            Place Order
                            </button>
                        ) : order.paypalOrderID && order.paypalOrderID === "pay-later" ? 
                        (
                            <button
                            className="accountOrderBtn"
                            onClick={(e) => {
                                e.stopPropagation();
                                transitionTo(`/make-payment/${order.orderInvoiceId ? "invoice" :"order"}/${order.orderInvoiceId ? order.orderInvoiceId : order.id}`, e);
                            }}
                            >
                            Pay
                            </button>
                        ) : order.paypalOrderID && order.paypalOrderID === "on-hold" ? (
                            "On Hold"
                        ) : order.paypalOrderID && order.paypalOrderID === "auto-billing" ?
                            //  order.orderInvoiceId ? 
                            //  <button
                            //   className="accountOrderBtn"
                            //   onClick={(e) => {
                            //     transitionTo(`/account/invoice/${order.orderInvoiceId}`, e);
                            //   }}
                            // >
                            //   View Invoice
                            // </button> : 
                            "-" : "Paid"}
                        </p>
                    )}
                    </td>
                )}
                {
                    <td onClick={(e) => e.stopPropagation} >
                    {order.sample ? <Trash onClick={() => onClickSampleDelete(order)}/> : 
                    <div
                        className="hardCopyAddressIconWrap"
                        ref={moreOptionsRef}
                        onClick={(e) => {
                        e.stopPropagation(); // Prevents event bubbling
                        }}
                        tabIndex={0} // Enables blur event for accessibility
                        onBlur={() => handleShowMore("")}

                    >
                        {moreOptions === order.id ? (
                        <MORESELECTED
                            className="hardCopyAddressIcon"
                            onClick={() => handleShowMore("")}
                        />
                        ) : (
                        <MORE
                            className="hardCopyAddressIcon"
                            onClick={(e) => {
                            e.stopPropagation(); // Prevents event bubbling
                            handleShowMore(order.id);
                            }}
                        />
                        )}

                        {moreOptions === order.id &&
                            (
                            <div className="hardCopyAddressEditWrap">
                            {
                            <div
                                className="hardCopyAddressEdit"
                                onClick={(e) => {e.stopPropagation(); handleDownloadOrder(order)}}
                            >
                                View Invoice
                            </div>}
                            {(order.status === "in-progress" || order.status === "new") && <div
                                className="hardCopyAddressEdit"
                                onClick={() => {
                                setSelectedCancelModal({
                                    id: order.id,
                                    orderNumber: order.orderNumber,
                                });
                                }}
                            >
                                Cancel Order
                            </div>}
                            {((order.paypalOrderID && order.paypalOrderID === "pay-later" && order.paypalOrderID !== "auto-billing" 
                                ) || order.status === "created")
                                && <div
                                className="hardCopyAddressEdit"
                                onClick={() => {
                                setSelectedSendPayment(order);
                                setMoreOptions("");
                                }}
                            >
                                Send Payment Link
                            </div>}
                            {/* { order.status === "completed" &&
                                <div
                                className="hardCopyAddressEdit accountDetailMoreBtnRow relative"
                                onClick={() => downloadPackage(order)}
                                >
                                <p>Download Package </p>
                                <INFO
                                    onMouseOver={() => {
                                    setShowDetailModal(
                                        order.id + "download-package"
                                    );
                                    }}
                                    onMouseLeave={() => {
                                    setShowDetailModal("");
                                    }}
                                />

                                {showDetailModal ===
                                    order.id + "download-package" && (
                                    <div className="accountdetailHoverBox !left-[30%] !top-[-70px]">
                                        <ul className="quotewidth  accountDetailslist">
                                        <li className="list-disc">
                                            Source files
                                        </li>
                                        <li className="list-disc">
                                            Translated files
                                        </li>
                                        <li className="list-disc">
                                            Revised files
                                        </li>
                                        <li className="list-disc">
                                            Invoice files
                                        </li>
                                        </ul>
                                    </div>
                                    )}
                                </div>
                                } */}
                            </div>
                        )}

                        {/* {moreOptions === order.id && (order.status === "in-progress") && <div className="hardCopyAddressEditWrap">
            <div className="hardCopyAddressEdit" onClick={() => {setSelectedCancelModal({id: order.id, orderNumber: order.orderNumber})}}>Cancel Order</div>
        </div>} */}

                      
                    </div>}
                    </td>
                }
                </tr>)
        })}
      </tbody>
      )
    }
 
    const handlePlaceOrder = async (orderData, paypalID) => {

      setPaylaterBtn("Placing Order...");
  
  
      await firestore
        .collection("orders")
        .doc(orderData.id)
        .update({
          paypalOrderID: paypalID,
          status: "new",
        })
        .then(() => {
          setTimeout(() => {
            setPaylaterBtn("Pay Later");
            setSelectedPayment("");
            if(orderData.expedited || orderData.expeditedPlus){
              decrTeamFreeExpedOrder(orderData.teamId);
            }
    
            if(localOrder.orderNumber === orderData.orderNumber){
              localStorage.setItem(
                "order",
                JSON.stringify({ orderID: "", name: "", email: "", parsed: true })
              );
              setOrder({ orderID: "", name: "", email: "", parsed: true });
            }
          }, 2000);
        })
        .catch((error) => {
          setPaylaterBtn("Pay Later");
          showNotification(
            "Error",
            "An error ocurred while finishing the order. Please, try again.",
            "error"
          );
        });
    };


  return (
    <>
      <Configure filters={filters} hitsPerPage={20}/>

      <QueryFilters
        setFilterStartTimestamp={setFilterStartTimestamp}
        filterStartTimestamp={filterStartTimestamp}
        setFilterEndTimestamp={setFilterEndTimestamp}
        filterEndTimestamp={filterEndTimestamp}
        setDatePeriod={setDatePeriod}
        datePeriod={datePeriod}
        setStatusFilter={setStatusFilter}
        statusFilter={statusFilter}
        setServicesFilter={setServicesFilter}
        servicesFilter={servicesFilter}
        setSelectedClients={setSelectedClients}
        selectedClients={selectedClients}
        setSelectedMembers={setSelectedMembers}
        selectedMembers={selectedMembers}
        setSelectedLanguageFilter={setSelectedLanguageFilter}
        selectedLanguageFilter={selectedLanguageFilter}
        baseUrl="/account/orders"
      />

    {openInvoiceModal && <OpenInvoiceModal type="order" order={openInvoiceModal} onClose={() => setOpenInvoiceModal(null)}/>}
    
    
    {selectedPayment && (
        <PopUpModal
          title={"Place Order"}
          backBtnText={paylaterBtn}
          subText={"Order Number: #"+selectedPayment.orderNumber}
          text={"Do you want to pay for this order now or later?"}
          btnText={"Pay Now"}
          hideIcon
          showClose
          onClose={() => setSelectedPayment("")}
          onClick={(e) =>
            transitionTo(`/make-payment/order/${selectedPayment.id}`, e)
          }
          onBackClick={() => {
            handlePlaceOrder(selectedPayment, "pay-later");
          }}
          disableBtn={paylaterBtn === "Placing Order..."}
        ></PopUpModal>
      )}
     {selectedCancelModal !== "" && (
        <PopUpModal
          title={"Cancel Order"}
          backBtnText="Back to Orders"
          subText="Are you sure you want to cancel this order?"
          text={selectedCancelModal.orderNumber}
          btnText={cancelBtnText}
          iconBgColor="#FFF6EA"
          deleteBtn={true}
          showClose
          onClose={() => setSelectedCancelModal("")}
          onClick={() => handleCancelOrder(selectedCancelModal.paypalOrderID !== "auto-billing" && selectedCancelModal.paypalOrderID !== "pay-later")}
          onBackClick={() => {
            setSelectedCancelModal("");
          }}
          disableBtn={cancelBtnText === "Cancelling..."}
          warningText={
            (selectedCancelModal.status === "in-progress" ||
                  selectedCancelModal.status === "assigned" || (selectedCancelModal.paypalOrderID !== "auto-billing" && selectedCancelModal.paypalOrderID !== "pay-later")) &&
            "Your order will be placed 'on Hold'. If the translator has started working on the translation, we’d reach you to confirm the cancellation details. You may be charged for the percentage of the translation work done."
          }
        >
          <CANCELORDER />
        </PopUpModal>
      )}

      {selectedSendPayment !== "" && (
        <SendPaymentLinkPopUp
          data={selectedSendPayment}
          type={selectedSendPayment.orderInvoiceId && selectedSendPayment.status !== "created" ? "invoice" : "order"}
          id={selectedSendPayment.orderInvoiceId  && selectedSendPayment.status !== "created" ? selectedSendPayment.orderInvoiceId : selectedSendPayment.id}
          onClose={() => setSelectedSendPayment("")}
        />
      )}
    
    <AccountNavBar
    windowSize={windowSize}
    selectedTab="orders"
    accountMainPadding={false}
    >
    <div className="accountMainTitleRow px-5 pt-5">
        <h2 className="accountMainTitle">Orders</h2>
        
        <SearchBox classNames={{
        root: "newSearchbox",
        form: "newSearchbox_form",
        input: "newSearchbox_input",
        reset: "hidden",
        loadingIndicator: "hidden",
        }} 
        placeholder="Search By ID, Client or Placed By" 
        submitIconComponent={() => <SEARCHICON/>} />
    </div>

    <div
    className={`grid grid-cols-2 ${teamData
        ? " xl:grid-cols-6 xl:w-fit lg:w-full md:grid-cols-3 "
        : " md:grid-cols-4 md:w-fit"
        } justify-center items-center gap-3 px-4  w-full`}
    >
    <div className="relative">
        <div
        className="accountDetailsFilter"
        style={{
            borderColor:
            showFilter === "date" ||
                filterStartTimestamp ||
                filterEndTimestamp
                ? "#12ABBF"
                : "#E6E7E9",
        }}
        onClick={(e) => {
            setShowFilter((f) => (f === "date" ? "" : "date"));
        }}
        >
        <DATE />
        <p className="accountDetailsFilterText">
            {getSelectedDateText()}
        </p>
        {showFilter === "date" ? <UP /> : <DOWN />}
        </div>
        {showFilter === "date" && (
        <DateFilter
            setShowModal={setShowFilter}
            startTimestamp={filterStartTimestamp}
            setStartTimestamp={setFilterStartTimestamp}
            endTimestamp={filterEndTimestamp}
            setEndTimestamp={setFilterEndTimestamp}
            period={datePeriod}
            setPeriod={setDatePeriod}
        />
        )}
    </div>
    <div className="relative">
        <div
        className="accountDetailsFilter"
        style={{
            borderColor:
            showFilter === "language" ||
                (selectedLanguageFilter.languageFrom !== "" &&
                selectedLanguageFilter.languageFrom !== "")
                ? "#12ABBF"
                : "#E6E7E9",
        }}
        onClick={(e) => {
            setShowFilter((f) => (f === "language" ? "" : "language"));
        }}
        >
        <LANGUAGES />
        <p className="accountDetailsFilterText">
            {getSelectedLanguage()}
        </p>
        {showFilter === "language" ? <UP /> : <DOWN />}
        </div>
        {showFilter === "language" && (
        <LanguageFilter
            setShowModal={setShowFilter}
            setSelectedLanguageFilter={setSelectedLanguageFilter}
            selectedLanguageFilter={selectedLanguageFilter}

        />
        )}
    </div>
    {teamData && teamMembers.length > 0 && (
        <div className="relative">
        <div
            className="accountDetailsFilter"
            style={{
            borderColor:
                showFilter === "placedBy" || selectedMembers.length > 0
                ? "#12ABBF"
                : "#E6E7E9",
            }}
            onClick={(e) => {
            setShowFilter((f) => (f === "placedBy" ? "" : "placedBy"));
            }}
        >
            <PLACEDBY />
            <p className="accountDetailsFilterText">
            Placed By{" "}
            {selectedMembers.length > 0
                ? ` (${selectedMembers.length}) `
                : ""}
            </p>
            {showFilter === "placedBy" ? <UP /> : <DOWN />}
        </div>
        {showFilter === "placedBy" && (
            <Clientsfilter
            setShowModal={setShowFilter}
            clients={teamMembers}
            setSelectedClients={setSelectedMembers}
            selectedClients={selectedMembers}
            />
        )}
        </div>
    )}
    {teamData && clients.length > 0 && (
        <div className="relative">
        <div
            className="accountDetailsFilter"
            style={{
            borderColor:
                showFilter === "client" ||
                selectedClients.length > 0
                ? "#12ABBF"
                : "#E6E7E9",
            }}
            onClick={() => {
            setShowFilter((f) =>
                f === "client" ? "" : "client"
            );
            }}
        >
            <CLIENT />
            <p className="accountDetailsFilterText">
            Client{" "}
            {selectedClients.length > 0
                ? ` (${selectedClients.length}) `
                : ""}
            </p>
            {showFilter === "client" ? <UP /> : <DOWN />}
        </div>
        {showFilter === "client" && (
            <Clientsfilter
            setShowModal={setShowFilter}
            clients={clients}
            setSelectedClients={setSelectedClients}
            selectedClients={selectedClients}
            isLast={true}
            isClientFilter={true}
            />
        )}
        </div>
    )}
    <div className="relative">
        <div
        className="accountDetailsFilter"
        style={{
            borderColor:
            showFilter === "services" || servicesFilter.length > 0
                ? "#12ABBF"
                : "#E6E7E9",
        }}
        onClick={(e) => {
            setShowFilter((f) => (f === "services" ? "" : "services"));
        }}
        >
        <SERVICES />
        <p className="accountDetailsFilterText">
            Services{" "}
            {servicesFilter.length > 0
            ? ` (${servicesFilter.length}) `
            : ""}
        </p>
        {showFilter === "services" ? <UP /> : <DOWN />}
        </div>
        {showFilter === "services" && (
        <SearchFilter
            type="services"
            setStatusFilter={setServicesFilter}
            selectedFilters={servicesFilter}
            setShowModal={setShowFilter}
        />
        )}
    </div>
    <div className="relative">
        <div
        className="accountDetailsFilter"
        style={{
            borderColor:
            showFilter === "status" || statusFilter !== ""
                ? "#12ABBF"
                : "#E6E7E9",
        }}
        onClick={(e) => {
            setShowFilter((f) => (f === "status" ? "" : "status"));
        }}
        >
        <STATUS />
        <p className="accountDetailsFilterText">
            Status
            {/* {statusFilter.length > 0 ? ` (${statusFilter.length}) ` : ""} */}
        </p>
        {showFilter === "status" ? <UP /> : <DOWN />}
        </div>
        {showFilter === "status" && (
        <SearchFilter
            type="status"
            accountType={userData.role}
            setStatusFilter={setStatusFilter}
            selectedFilters={statusFilter}
            setShowModal={setShowFilter}
            isLast={true}
        />
        )}
    </div>
    </div>

    <div className="accountDetailsScroll w-full">
        {loading ? <NoData loadingText={"orders"} loading={true} showBtn={false} type="orders"/> :
        (!checkFetchAlgoliaData() ? localOrders.length === 0 : hits.length === 0) && (!showSampleOrders && (sampleOrders && sampleOrders.length === 0)) &&
        <NoData
        type="order"
        text={checkAnyFilterSelected() || query !== "" ? "Please select another filter" : ""}
        title={checkAnyFilterSelected() || query !== "" ? "No Order Matching This Filter": "You Don't Have Any Active Order Yet"}
        showBtn={!checkAnyFilterSelected() || query === ""}
        btnText={"Create Order"}
        onClick={() => {
          transitionTo("/order/documents");
        }}
        /> }
        {((!checkFetchAlgoliaData() ? localOrders.length > 0 : hits.length > 0) || (showSampleOrders && sampleOrders && sampleOrders.length > 0)) && !loading &&
        <table className="accountDetailsTable" style={{display: loading ? "none" : "table"}}>
            <thead>
                <tr>
                   {showSampleOrders && (!checkFetchAlgoliaData() ? localOrders.length === 0 : hits.length === 0) ? <th></th> : ""}
                    <th>
                    <p className="accountDetailsHeading">ID</p>
                    </th>
                    <th>
                    <div className="accountData">
                        <p className="accountDetailsHeading">Date</p>
                        { currentRefinement === "order_time_dsc" ? 
                        <SORT_DSC className="sortIcon" onClick={() => refine("order_time_asc")}/> 
                        : currentRefinement === "order_time_asc" ?
                        <SORT_ASC className="sortIcon" onClick={() => refine("order_time_dsc")}/> 
                        : <SORTBLACK className="sortIcon" onClick={() => refine("order_time_dsc")}/>
                        }
                    </div>
                    </th>
                    <th>
                    <div className="accountData">
                        <p className="accountDetailsHeading">Languages</p>
                    </div>
                    </th>
                    {userData && userData.teamId && (
                    <th>
                        <div className="accountData">
                        <p className="accountDetailsHeading">Placed By</p>
                        { currentRefinement === "order_requestBy_dsc" ? 
                        <SORT_DSC className="sortIcon" onClick={() => refine("order_requestBy_asc")}/> 
                        : currentRefinement === "order_requestBy_asc" ?
                        <SORT_ASC className="sortIcon" onClick={() => refine("order_requestBy_dsc")}/> 
                        : <SORTBLACK className="sortIcon" onClick={() => refine("order_requestBy_asc")}/>
                        }
                        </div>
                    </th>
                    )}
                    {userData && userData.teamId && (
                    <th>
                    <div className="accountData">
                        <p className="accountDetailsHeading">Client</p>
                        { currentRefinement === "order_client_dsc" ? 
                        <SORT_DSC className="sortIcon" onClick={() => refine("order_client_asc")}/> 
                        : currentRefinement === "order_client_asc" ?
                        <SORT_ASC className="sortIcon" onClick={() => refine("order_client_dsc")}/> 
                        : <SORTBLACK className="sortIcon" onClick={() => refine("order_client_asc")}/>
                        }
                    </div>
                    </th>
                    )}
                    <th>
                    <div className="accountData">
                        <p className="accountDetailsHeading">Services</p>
                    </div>
                    </th>
                    <th>
                    <div className="accountData">
                        {showDetailModal === "add-comment" && (
                        <div className="accountdetailHoverBox tooltip-bottom">
                            <p className="quotewidth ">Chat</p>
                        </div>
                        )}
                        <MESSAGE
                        style={{ cursor: "pointer" }}
                        onMouseOver={() => setShowDetailModal("add-comment")}
                        onMouseLeave={() => setShowDetailModal("")}
                        />
                    </div>
                    </th>
                    <th>
                    <div className="accountData">
                        <p className="accountDetailsHeading">Status</p>
                        { currentRefinement === "order_status_dsc" ? 
                        <SORT_DSC className="sortIcon" onClick={() => refine("order_status_asc")}/> 
                        : currentRefinement === "order_status_asc" ?
                        <SORT_ASC className="sortIcon" onClick={() => refine("order_status_dsc")}/> 
                        : <SORTBLACK className="sortIcon" onClick={() => refine("order_status_asc")}/>
                        }
                    </div>
                    </th>
                    <th>
                    <div className="accountData">
                        <p className="accountDetailsHeading">Total</p>
                        {/* { currentRefinement === "invoice_time_dsc" ? 
                        <SORT_DSC className="sortIcon" onClick={() => refine("invoice_time_asc")}/> 
                        : currentRefinement === "invoice_time_asc" ?
                        <SORT_ASC className="sortIcon" onClick={() => refine("invoice_time_dsc")}/> 
                        : <SORTBLACK className="sortIcon" onClick={() => refine("invoice_time_dsc")}/>
                        } */}
                    </div>
                    </th>
                    {checkAutoBilling(teamData) ? null : (
                    <th>
                        <div
                        className="accountData"
                        style={{ justifyContent: "center"}}
                        >
                        <p className="accountDetailsHeading">Payment</p>
                        {/* { currentRefinement === "invoice_time_dsc" ? 
                        <SORT_DSC className="sortIcon" onClick={() => refine("invoice_time_asc")}/> 
                        : currentRefinement === "invoice_time_asc" ?
                        <SORT_ASC className="sortIcon" onClick={() => refine("invoice_time_dsc")}/> 
                        : <SORTBLACK className="sortIcon" onClick={() => refine("invoice_time_dsc")}/>
                        } */}
                        </div>
                    </th>
                    )}
                    <th></th>
                </tr>
            </thead>

            <TableDataComponent hits={!checkFetchAlgoliaData() ? localOrders : hits}/>

        </table>}
        {hits.length > 0 && 
        <Pagination
        padding={0}
        showFirst={false}
        showPrevious={true}
        showNext={true}
        showLast={false}
        classNames={{
            root: "w-full my-4 mx-2",
            list: "w-full flex justify-center items-center gap-2",
            item: "",
            selectedItem:"",
            disabledItem:"opacity-50 cursor-not-allowed",
            previousPageItem: "px-4 py-1 font-medium bg-primary text-white rounded-md hover:bg-primary/70 transition",
            nextPageItem: "px-4 py-1 font-medium bg-primary text-white rounded-md hover:bg-primary/70 transition",
            firstPageItem: "px-4 py-1 font-medium bg-primary text-white rounded-md hover:bg-primary/70 transition",
            lastPageItem: "px-4 py-1 font-medium bg-primary text-white rounded-md hover:bg-primary/70 transition",
        }}
        translations={{
        previousPageItemText: 'Previous',
        nextPageItemText: 'Next',
        pageItemText: ({ currentPage, nbPages }) => `Page ${currentPage}`,
        previousPageItemAriaLabel: 'Go to previous page',
        nextPageItemAriaLabel: 'Go to next page',
        pageItemAriaLabel: ({ currentPage, nbPages }) => `Go to page ${currentPage} of ${nbPages}`,
        }}
        />}
    </div>
    
    </AccountNavBar>
    </>
  );
};

export default AccountOrdersComponent;
